import Badge from 'react-bootstrap/Badge';
import './coveredServicesCost.scss';
import { Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import CopaymentNetwork from './copaymentNetwork.js';

export const CostCard = (costDetails) => {
  const { selectedMember } = useSelector((state) => state.memberModule);
  let inNetworkAccums = {};
  let penaltyAccums = {};
  let outOfAreaAccums = {};
  let coPayValue = '';
  let coPaymentExists = 'N/A';
  const calculateCoPay = (accums) => {
    if (accums) {
      if (accums['OfficeVisitCoPay'] !== undefined) {
        const officeVisitCoPayVal = +accums['OfficeVisitCoPay'].Amount;
        if (isNaN(officeVisitCoPayVal) == true) {
          const fields = accums['OfficeVisitCoPay'].Amount.split('<br/>');
          const coPayFirstVal = fields[0].substring(
            fields[0].length,
            fields[0].indexOf('$'),
          );
          coPayValue = coPayFirstVal;
          coPaymentExists = true;
        } else {
          if (officeVisitCoPayVal !== 0) {
            coPayValue = officeVisitCoPayVal;
            coPaymentExists = true;
          }
          if (accums['InPatientCoPay'] !== undefined) {
            const inPatientCoPayVal = +accums['InPatientCoPay'].Amount;
            if (isNaN(inPatientCoPayVal) == true) {
              const fields = accums['InPatientCoPay'].Amount.split('<br/>');
              const coPayFirstVal = fields[0].substring(
                fields[0].length,
                fields[0].indexOf('$'),
              );
              coPayValue = coPayFirstVal;
              coPaymentExists = true;
            } else {
              if (inPatientCoPayVal !== 0) {
                coPayValue = inPatientCoPayVal;
                coPaymentExists = true;
              }
              if (accums['IndependentLabCoPay'] !== undefined) {
                const independentLabCoPayVal =
                  +accums['IndependentLabCoPay'].Amount;
                if (isNaN(independentLabCoPayVal) == true) {
                  const fields =
                    accums['IndependentLabCoPay'].Amount.split('<br/>');
                  const coPayFirstVal = fields[0].substring(
                    fields[0].length,
                    fields[0].indexOf('$'),
                  );
                  coPayValue = coPayFirstVal;
                  coPaymentExists = true;
                } else {
                  if (independentLabCoPayVal !== 0) {
                    coPayValue = independentLabCoPayVal;
                    coPaymentExists = true;
                  }
                  if (accums['FacilityLabCoPay'] !== undefined) {
                    const facilityLabCoPayVal =
                      +accums['FacilityLabCoPay'].Amount;
                    if (isNaN(facilityLabCoPayVal) == true) {
                      const fields =
                        accums['FacilityLabCoPay'].Amount.split('<br/>');
                      const coPayFirstVal = fields[0].substring(
                        fields[0].length,
                        fields[0].indexOf('$'),
                      );
                      coPayValue = coPayFirstVal;
                      coPaymentExists = true;
                    } else {
                      if (facilityLabCoPayVal !== 0) {
                        coPayValue = facilityLabCoPayVal;
                        coPaymentExists = true;
                      }
                    }
                    //when all copay values are 0.00
                    coPayValue = '$500.00';
                    coPaymentExists = false;
                  }
                }
              }
            }
          }
        }
      }
    }
    return { coPayValue, coPaymentExists };
  };

  costDetails.accumsDetails.map((accum) => {
    if (accum.NetworkName == 'Out Of Area') {
      const result = calculateCoPay(accum);
      if (costDetails?.isFamilySelected) {
        outOfAreaAccums = {
          coPaymentExists: result.coPaymentExists,
          deductiableIsWaivedOff:
            accum?.OutOfAreaBenefitScheduleExceptions?.ApplyPlanDeductible ===
            '1'
              ? false
              : true,
          preCertification:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.ApplyPreCertificationPenalty,
          coPaymentAmount: result.coPayValue,
          coInsurancePercentage: Math.round(+accum?.Coinsurance?.Percent),

          annualAccumAmount: +accum?.InNetworkAnnualAccums?.FamilyAmount,
          lifeTimeAccumAmount: +accum?.InNetworkLifeAccums?.FamilyAmount,
          annualAccumVisits: +accum?.InNetworkAnnualAccums?.FamilyVisits,
          lifeTimeAccumVisits: +accum?.InNetworkLifeAccums?.FamilyVisits,

          annualMaxAmount:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.PaymentLimitAmountFamilyAnnualLimit,
          annualMaxVisits:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.VisitLimitFamilyAnnualLimit,
          lifeTimeMaxAmount:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.PaymentLimitAmountFamilyPerLifetime,
          lifeTimeMaxVisits:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.VisitLimitFamilyPerLifetime,
          deductible: accum?.FamilyDeductible,
          outPfPocket: accum?.FamilyOutOfPocket,
        };
      } else {
        outOfAreaAccums = {
          coPaymentExists: result.coPaymentExists,
          deductiableIsWaivedOff:
            accum?.OutOfAreaBenefitScheduleExceptions?.ApplyPlanDeductible ===
            '1'
              ? false
              : true,
          preCertification:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.ApplyPreCertificationPenalty,
          coPaymentAmount: result.coPayValue,
          coInsurancePercentage: Math.round(+accum?.Coinsurance?.Percent),

          annualAccumAmount: +accum?.InNetworkAnnualAccums?.PatientAmount,
          lifeTimeAccumAmount: +accum?.InNetworkLifeAccums?.PatientAmount,
          annualAccumVisits: +accum?.InNetworkAnnualAccums?.PatientVisits,
          lifeTimeAccumVisits: +accum?.InNetworkLifeAccums?.PatientVisits,

          annualMaxAmount:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.PaymentLimitAmountIndividualAnnualLimit,
          annualMaxVisits:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.VisitLimitIndividualAnnualLimit,
          lifeTimeMaxAmount:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.PaymentLimitAmountIndividualPerLifetime,
          lifeTimeMaxVisits:
            accum?.OutOfAreaBenefitScheduleExceptions
              ?.VisitLimitIndividualPerLifetime,
          deductible: accum?.IndividualDeductible,
          outPfPocket: accum?.IndividualOutOfPocket,
        };
      }
    } else if (accum.NetworkName == 'Penalty Network') {
      const result = calculateCoPay(accum);
      if (costDetails?.isFamilySelected) {
        penaltyAccums = {
          coPaymentExists: result.coPaymentExists,
          deductiableIsWaivedOff:
            accum?.PenaltyBenefitScheduleExceptions?.ApplyPlanDeductible === '1'
              ? false
              : true,
          preCertification:
            accum?.PenaltyBenefitScheduleExceptions
              ?.ApplyPreCertificationPenalty,
          coPaymentAmount: result.coPayValue,
          coInsurancePercentage: Math.round(+accum?.Coinsurance?.Percent),

          annualAccumAmount: +accum?.InNetworkAnnualAccums?.FamilyAmount,
          lifeTimeAccumAmount: +accum?.InNetworkLifeAccums?.FamilyAmount,
          annualAccumVisits: +accum?.InNetworkAnnualAccums?.FamilyVisits,
          lifeTimeAccumVisits: +accum?.InNetworkLifeAccums?.FamilyVisits,

          annualMaxAmount:
            accum?.PenaltyBenefitScheduleExceptions
              ?.PaymentLimitAmountFamilyAnnualLimit,
          annualMaxVisits:
            accum?.PenaltyBenefitScheduleExceptions
              ?.VisitLimitFamilyAnnualLimit,
          lifeTimeMaxAmount:
            accum?.PenaltyBenefitScheduleExceptions
              ?.PaymentLimitAmountFamilyPerLifetime,
          lifeTimeMaxVisits:
            accum?.PenaltyBenefitScheduleExceptions
              ?.VisitLimitFamilyPerLifetime,
          deductible: accum?.FamilyDeductible,
          outPfPocket: accum?.FamilyOutOfPocket,
        };
      } else {
        penaltyAccums = {
          coPaymentExists: result.coPaymentExists,
          deductiableIsWaivedOff:
            accum?.PenaltyBenefitScheduleExceptions?.ApplyPlanDeductible === '1'
              ? false
              : true,
          preCertification:
            accum?.PenaltyBenefitScheduleExceptions
              ?.ApplyPreCertificationPenalty,
          coPaymentAmount: result.coPayValue,
          coInsurancePercentage: Math.round(+accum?.Coinsurance?.Percent),

          annualAccumAmount: +accum?.InNetworkAnnualAccums?.PatientAmount,
          lifeTimeAccumAmount: +accum?.InNetworkLifeAccums?.PatientAmount,
          annualAccumVisits: +accum?.InNetworkAnnualAccums?.PatientVisits,
          lifeTimeAccumVisits: +accum?.InNetworkLifeAccums?.PatientVisits,

          annualMaxAmount:
            accum?.PenaltyBenefitScheduleExceptions
              ?.PaymentLimitAmountIndividualAnnualLimit,
          annualMaxVisits:
            accum?.PenaltyBenefitScheduleExceptions
              ?.VisitLimitIndividualAnnualLimit,
          lifeTimeMaxAmount:
            accum?.PenaltyBenefitScheduleExceptions
              ?.PaymentLimitAmountIndividualPerLifetime,
          lifeTimeMaxVisits:
            accum?.PenaltyBenefitScheduleExceptions
              ?.VisitLimitIndividualPerLifetime,
          deductible: accum?.IndividualDeductible,
          outPfPocket: accum?.IndividualOutOfPocket,
        };
      }
    } else {
      const result = calculateCoPay(accum);
      if (costDetails?.isFamilySelected) {
        inNetworkAccums = {
          coPaymentExists: result.coPaymentExists,
          deductiableIsWaivedOff:
            accum?.InNetworkBenefitScheduleExceptions?.ApplyPlanDeductible ===
            '1'
              ? false
              : true,
          preCertification:
            accum?.InNetworkBenefitScheduleExceptions
              ?.ApplyPreCertificationPenalty,
          coPaymentAmount: result.coPayValue,
          coInsurancePercentage: Math.round(+accum?.Coinsurance?.Percent),

          annualAccumAmount: +accum?.InNetworkAnnualAccums?.FamilyAmount,
          lifeTimeAccumAmount: +accum?.InNetworkLifeAccums?.FamilyAmount,
          annualAccumVisits: +accum?.InNetworkAnnualAccums?.FamilyVisits,
          lifeTimeAccumVisits: +accum?.InNetworkLifeAccums?.FamilyVisits,

          annualMaxAmount:
            accum?.InNetworkBenefitScheduleExceptions
              ?.PaymentLimitAmountFamilyAnnualLimit,
          annualMaxVisits:
            accum?.InNetworkBenefitScheduleExceptions
              ?.VisitLimitFamilyAnnualLimit,
          lifeTimeMaxAmount:
            accum?.InNetworkBenefitScheduleExceptions
              ?.PaymentLimitAmountFamilyPerLifetime,
          lifeTimeMaxVisits:
            accum?.InNetworkBenefitScheduleExceptions
              ?.VisitLimitFamilyPerLifetime,
          deductible: accum?.FamilyDeductible,
          outPfPocket: accum?.FamilyOutOfPocket,
        };
      } else {
        inNetworkAccums = {
          coPaymentExists: result.coPaymentExists,
          deductiableIsWaivedOff:
            accum?.InNetworkBenefitScheduleExceptions?.ApplyPlanDeductible ===
            '1'
              ? false
              : true,
          preCertification:
            accum?.InNetworkBenefitScheduleExceptions
              ?.ApplyPreCertificationPenalty,
          coPaymentAmount: result.coPayValue,
          coInsurancePercentage: Math.round(+accum?.Coinsurance?.Percent),

          annualAccumAmount: +accum?.InNetworkAnnualAccums?.PatientAmount,
          lifeTimeAccumAmount: +accum?.InNetworkLifeAccums?.PatientAmount,
          annualAccumVisits: +accum?.InNetworkAnnualAccums?.PatientVisits,
          lifeTimeAccumVisits: +accum?.InNetworkLifeAccums?.PatientVisits,

          annualMaxAmount:
            accum?.InNetworkBenefitScheduleExceptions
              ?.PaymentLimitAmountIndividualAnnualLimit,
          annualMaxVisits:
            accum?.InNetworkBenefitScheduleExceptions
              ?.VisitLimitIndividualAnnualLimit,
          lifeTimeMaxAmount:
            accum?.InNetworkBenefitScheduleExceptions
              ?.PaymentLimitAmountIndividualPerLifetime,
          lifeTimeMaxVisits:
            accum?.InNetworkBenefitScheduleExceptions
              ?.VisitLimitIndividualPerLifetime,
          deductible: accum?.IndividualDeductible,
          outPfPocket: accum?.IndividualOutOfPocket,
        };
      }
    }
  });

  const [inCoverageCopayments, setInCoverageCopayments] =
    useState(inNetworkAccums);
  const [outCoverageCopayments, setOutInCoverageCopayments] =
    useState(outOfAreaAccums);
  const [penaltyCoverageCopayments, setPenaltyCoverageCopayments] =
    useState(penaltyAccums);
  const { Display_Penalty_OR_OutOfNetwork } =
    useSelector((state) => state.app.appConfigs.Network_Setting) ||
    'Out-Of-Network';
  console.log(costDetails, 'PlanInfo');
  return (
    <>
      <Row className="mt-2">
        <Col md={4} className="mb-3 mb-md-0">
          <div className="cost-cards">
            <CopaymentNetwork
              coverageCopayments={inCoverageCopayments}
              accumsDetails={costDetails.accumsDetails}
              network={'In Network'}
              isNotFound={costDetails?.isNotFound}
              isAPIFailed={costDetails?.isAPIFailed}
              NetworkExclusionFlag={false}
              dataFetching={costDetails?.dataFetching}
            />
          </div>
        </Col>
        {Display_Penalty_OR_OutOfNetwork === 'Penalty' ? (
          <Col md={4} className="mb-3 mb-md-0">
            <div className="cost-cards">
              <CopaymentNetwork
                coverageCopayments={penaltyCoverageCopayments}
                accumsDetails={costDetails.accumsDetails}
                network={'Penalty'}
                isNotFound={costDetails?.isNotFound}
                isAPIFailed={costDetails?.isAPIFailed}
                NetworkExclusionFlag={false}
                dataFetching={costDetails?.dataFetching}
              />
            </div>
          </Col>
        ) : (
          <Col md={4} className="mb-3 mb-md-0">
            <div className="cost-cards">
              <CopaymentNetwork
                coverageCopayments={outCoverageCopayments}
                accumsDetails={costDetails.accumsDetails}
                network={'Out of Network'}
                isNotFound={costDetails?.isNotFound}
                isAPIFailed={costDetails?.isAPIFailed}
                NetworkExclusionFlag={false}
                dataFetching={costDetails?.dataFetching}
              />
            </div>
          </Col>
        )}
      </Row>
      {/*{
        <Card.Text>
          Precertification Required: <b className="co-pay">No</b>
        </Card.Text>
      } */}
    </>
  );
};
